<template lang="html">

    <div class="wrapper -home">
  
      <section class="intro -vivir-experiencias column-center">
  
        <h1 class="big-title column-center">
          <strong>A Jaén</strong>
          <span>A vivir experiencias</span>
        </h1>
  
      </section>
  
  
  
      <section class="categorias-home column-center">
  
        <h3>
          ¡6 meses cargados de experiencias!
        </h3>

        <div class="texto container">
          <h4>Jaén es el #DestinoSeguro para reencontrarte con tu espíritu viajero.</h4>
          <p>Y para ponértelo más fácil te ofrecemos <strong>gratis al reservar tu alojamiento</strong> en cualquier establecimiento de la ciudad y/o provincia de Jaén una gran variedad de actividades con las que disfrutar otra forma de hacer turismo.</p>
          <p>Elige tú mismo <strong>cómo va a ser tu próxima escapada al paraíso</strong> interior de Andalucía, desde julio hasta la navidad.</p>
        </div>
          
          <h2 class="big-title -small">
          <strong>Experiencias</strong>
        </h2>
  
        <div class="categorias container row-between">
          <article class="categoria-square -iberos column-between">
            <div class="contenedor-imagen">
              <img src="/static/img/logo-iberos.svg" alt="Logo iberos">
            </div>
            <h2>A descubrir historia</h2>
            <a class="btn-skull">Ver actividades</a>
            <router-link :to="$t('enlaces.categoria')+$t('enlaces.categorias.iberos')" class="enlace-cover"></router-link>
            <div class="contenedor-boton">
              <a target="_blank" href="/static/pdf/folleto-actividades-iberos.pdf" class="">Descargar folleto ></a>
            </div>
          </article>
          <article class="categoria-square -castillos column-between">
            <div class="contenedor-imagen">
              <img src="/static/img/logo-castillos-y-batallas.svg" alt="Logo castillos y batallas">
            </div>
            <h2>A pasear sus castillos</h2>
            <a class="btn-skull">Ver actividades</a>
            <router-link :to="$t('enlaces.categoria')+$t('enlaces.categorias.castillos')" class="enlace-cover"></router-link>
            <div class="contenedor-boton">
              <a target="_blank" href="/static/pdf/folleto-actividades-castillos-y-batallas.pdf" class="btn-negro">Descargar folleto ></a>
            </div>
          </article>
          <article class="categoria-square -aventura column-between">
            <div class="contenedor-imagen">
              <img src="/static/img/logo-aventura.svg" alt="Logo aventuras">
            </div>
            <h2>A vivir<br>emociones</h2>
            <a class="btn-skull">Ver actividades</a>
            <router-link :to="$t('enlaces.categoria')+$t('enlaces.categorias.aventura')" class="enlace-cover"></router-link>
            <div class="contenedor-boton">
              <!-- <a target="_blank" href="/static/pdf/folleto-actividades-aventura.pdf" class="">Descargar folleto ></a> -->
            </div>
          </article>
        </div>
  
      </section>
  

    </div>
  
  </template>
  
  <script lang="js">
  
  
    export default {
      name: 'vivir-experiencias',
      components : {
      }
    }
      
  </script>
  
  
  <style lang="scss">
  
  </style>
  


// WEBPACK FOOTER //
// src/components/views/vivir-experiencias.vue